module.exports = __webpack_public_path__ + "static/img/7-5.9ae4bdf6.jpg";